import { defineMessages } from 'react-intl-next';
export default defineMessages({
  white: {
    id: 'fabric.theme.white',
    defaultMessage: 'White',
    description: 'Name of a color'
  },
  'light-blue': {
    id: 'fabric.theme.light-blue',
    defaultMessage: 'Light blue',
    description: 'Name of a color'
  },
  'light-teal': {
    id: 'fabric.theme.light-teal',
    defaultMessage: 'Light teal',
    description: 'Name of a color'
  },
  'light-green': {
    id: 'fabric.theme.light-green',
    defaultMessage: 'Light green',
    description: 'Name of a color'
  },
  'light-yellow': {
    id: 'fabric.theme.light-yellow',
    defaultMessage: 'Light yellow',
    description: 'Name of a color'
  },
  'light-red': {
    id: 'fabric.theme.light-red',
    defaultMessage: 'Light red',
    description: 'Name of a color'
  },
  'light-purple': {
    id: 'fabric.theme.light-purple',
    defaultMessage: 'Light purple',
    description: 'Name of a color'
  },
  'light-gray': {
    id: 'fabric.theme.light-gray',
    defaultMessage: 'Light gray',
    description: 'Name of a color'
  },
  blue: {
    id: 'fabric.theme.blue',
    defaultMessage: 'Blue',
    description: 'Name of a color'
  },
  teal: {
    id: 'fabric.theme.teal',
    defaultMessage: 'Teal',
    description: 'Name of a color'
  },
  green: {
    id: 'fabric.theme.green',
    defaultMessage: 'Green',
    description: 'Name of a color'
  },
  yellow: {
    id: 'fabric.theme.yellow',
    defaultMessage: 'Yellow',
    description: 'Name of a color'
  },
  red: {
    id: 'fabric.theme.red',
    defaultMessage: 'Red',
    description: 'Name of a color.'
  },
  orange: {
    id: 'fabric.theme.orange',
    defaultMessage: 'Orange',
    description: 'Name of a color.'
  },
  purple: {
    id: 'fabric.theme.purple',
    defaultMessage: 'Purple',
    description: 'Name of a color'
  },
  gray: {
    id: 'fabric.theme.gray',
    defaultMessage: 'Gray',
    description: 'Name of a color'
  },
  'dark-blue': {
    id: 'fabric.theme.dark-blue',
    defaultMessage: 'Dark blue',
    description: 'Name of a color'
  },
  'dark-teal': {
    id: 'fabric.theme.dark-teal',
    defaultMessage: 'Dark teal',
    description: 'Name of a color'
  },
  'dark-green': {
    id: 'fabric.theme.dark-green',
    defaultMessage: 'Dark green',
    description: 'Name of a color'
  },
  'dark-yellow': {
    id: 'fabric.theme.dark-yellow',
    defaultMessage: 'Dark yellow',
    description: 'Name of a color'
  },
  'dark-red': {
    id: 'fabric.theme.dark-red',
    defaultMessage: 'Dark red',
    description: 'Name of a color'
  },
  'dark-purple': {
    id: 'fabric.theme.dark-purple',
    defaultMessage: 'Dark purple',
    description: 'Name of a color'
  },
  'subtle-gray': {
    id: 'fabric.theme.subtle-gray',
    defaultMessage: 'Subtle gray',
    description: 'Name of a color'
  },
  'bold-gray': {
    id: 'fabric.theme.bold-gray',
    defaultMessage: 'Bold gray',
    description: 'Name of a color'
  },
  // Colors only used in highlight palette
  'no-color': {
    id: 'fabric.theme.no-color',
    defaultMessage: 'No highlight',
    description: 'Tooltip for the no color option in the highlight color palette in the main editor toolbar'
  },
  lime: {
    id: 'fabric.theme.lime',
    defaultMessage: 'Lime',
    description: "Tooltip for the lime color used in the main toolbar's highlight color palette"
  },
  magenta: {
    id: 'fabric.theme.magenta',
    defaultMessage: 'Magenta',
    description: "Tooltip for the magenta color used in the main toolbar's highlight color palette"
  }
});